import type { BreadcrumbList, WithContext } from "schema-dts";

type Props = {
	breadcrumbs?: Array<{ name: string; path?: string | null }> | null;
};

export const BreadcrumbsJsonLd = ({ breadcrumbs }: Props) => {
	const hasBreadcrumbs = breadcrumbs && breadcrumbs.length > 0;

	if (!hasBreadcrumbs) return null;

	const jsonLd: WithContext<BreadcrumbList> = {
		"@context": "https://schema.org",
		"@type": "BreadcrumbList",
		itemListElement: breadcrumbs
			.filter((b) => b.path)
			.map(({ name, path }, index) => ({
				"@type": "ListItem",
				position: index + 1,
				name: name,
				item: path as string,
			})),
	};

	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
		/>
	);
};
